import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import {
  Box,
  Button,
  Container,
  Link,
  TextField,
  Typography,
  makeStyles
} from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import Logo from 'src/shared/ui/components/Logo';
import MENU_ITEMS from 'src/shared/ui/layouts/menu-items';

import authorizeUser from '../../use-cases/authorizeUser';
import credentialsSchema from '../../models/CredentialsSchema';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3)
  }
}));

const LoginView = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const checkCredentials = async (formValues) => {
    console.log('checkCredentials');
    const { email, password } = formValues;
    const res = await authorizeUser(email, password);
    if (res.statusCode === 200 && res.user?.scopes) {
      const canShowMenuItem = (menuItem) => {
        return menuItem.scope.every((item) => {
          return res.user.scopes.includes(item);
        });
      };

      const allowedMenuItems = MENU_ITEMS.filter(canShowMenuItem);
      const defaultHomePage = allowedMenuItems[0].href;
      navigate(defaultHomePage, {
        replace: true
      });
    } else {
      try {
        delete localStorage.accessToken;
        delete localStorage.userHeadquarterList;
        delete localStorage.selectedUserHeadquarter;
        delete localStorage.user;
        delete localStorage.____________________;
      } catch (e) {
        console.log(e);
      }

      alert('Usuario y/o contraseña incorrectos');
    }
  };

  const formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: credentialsSchema,
    onSubmit: (formValues) => checkCredentials(formValues)
  });

  return (
    <Page className={classes.root} title="Login">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Box display="flex" justifyContent="center" alignItems="center">
            <Logo type="vertical" />
          </Box>
          <form onSubmit={formik.handleSubmit}>
            <Box mb={3}>
              <Typography color="textSecondary" variant="body2">
                Bienvenido a SmartCash, introducí tu email y contraseña para
                ingresar.
              </Typography>
            </Box>
            <TextField
              error={Boolean(formik.touched.email && formik.errors.email)}
              fullWidth
              helperText={formik.touched.email && formik.errors.email}
              label="Email"
              margin="normal"
              name="email"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type="email"
              autoComplete="email"
              value={formik.values.email}
              variant="outlined"
            />
            <TextField
              error={Boolean(formik.touched.password && formik.errors.password)}
              fullWidth
              helperText={formik.touched.password && formik.errors.password}
              label="Contraseña"
              margin="normal"
              name="password"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type="password"
              value={formik.values.password}
              autoComplete="current-password"
              variant="outlined"
            />
            <Box my={2}>
              <Button
                color="primary"
                disabled={formik.isSubmitting}
                fullWidth
                size="large"
                type="submit"
                variant="contained"
              >
                Ingresar
              </Button>
            </Box>
            <Typography color="textSecondary" variant="body1">
              ¿Olvidó su contraseña?{' '}
              <Link component={RouterLink} to="/login" variant="h6">
                Haga click acá para recuperarla
              </Link>
            </Typography>
          </form>
        </Container>
      </Box>
    </Page>
  );
};

export default LoginView;
